export const PHONE_LENGTHS: Record<string, number> = {
  "971": 9,
  "91": 10,
  "1": 10,
  "44": 10,
  "966": 9,
  "61": 9,
  "49": 10,
  "33": 9,
  "39": 10,
  "34": 9,
  "81": 10,
  "86": 11,
  "65": 8,
  "60": 9,
};
